import {DefaultSettings, settings} from '../../../settings/settings-util';
import Renderer from './renderers/renderer';
import reduceReducers from 'reduce-reducers';
import {AlmeState, defaultState} from "../../../wireup/AlmeState";
import {Mutator} from "../../../types/rendering";
import {Reducer, Store} from "redux";
import {HistoryMessage} from "../../../types/history";
import {VChild} from "virtual-dom";


type ChildComponent = { getRenderer: () => ComponentRenderer; getReducer: () => Reducer<AlmeState> };
type ComponentRenderer = (message: HistoryMessage) => VChild;
type MutatorModule = { getMutator: () => Mutator };


export default class UserMessageRenderer
{

    _settings: DefaultSettings;
    _renderer: Renderer;
    _mutatorModules: MutatorModule[];
    _childComponents: ChildComponent[];

    _mutators: Mutator[] = [];
    _childRenderers: ComponentRenderer[] = [];


    //#region Public Interface

    constructor(passedSettings?: DefaultSettings,
                mutatorModules: MutatorModule[] = [],
                childComponents: ChildComponent[] = [])
    {
        this._settings = passedSettings ?? settings;
        this._renderer = new Renderer(this._settings);
        this._mutatorModules = mutatorModules;
        this._childComponents = childComponents;
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._mutators = this._mutatorModules.map(module => module.getMutator());
        this._childRenderers = this._childComponents.map(component => component.getRenderer());

        this._renderer.initialize(store, this._mutators, this._childRenderers);
    }

    getReducer(): Reducer<AlmeState>
    {
        const childComponentReducers = this._childComponents.map(component => component.getReducer());

        return reduceReducers(defaultState, ...childComponentReducers);
    }

    getRenderer(): (message: HistoryMessage) => VChild
    {
        return this._renderer.getRender();
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-user/src/message-renderer-user.ts